import moment from "moment-timezone";
import UtilService from "./util.service";

const CustomReportService = {
  store: null,
  init(opts) {
    if (opts.store) {
      this.store = opts.store;
    }
  },

  isObject(value) {
    return (typeof value === "object" || typeof value === "function") && value !== null;
  },

  /**
   * Display filter value for a custom report filter
   *
   * @param {*} filter
   * @returns display value
   */
  displayFilterValue(filter) {
    let displayValue = "";
    if (filter && this.isObject(filter.value) && filter.value.id) {
      if (filter.filterType.objectKey && filter.value[filter.filterType.objectKey]) {
        displayValue += filter.value[filter.filterType.objectKey];
      }
      if (displayValue.length == 0) {
        displayValue += filter.value.id;
      }
    } else if (
      filter &&
      filter.filterType &&
      filter.filterType.name.startsWith("DATE") &&
      moment(filter.value).isValid()
    ) {
      if (this.store.getters.selectedClient) {
        displayValue = UtilService.formatDateClient(
          filter.value,
          "MM/DD/YYYY hh:mm a z",
          this.store.getters.selectedClient
        );
      } else {
        displayValue = filter.value;
      }
    } else {
      displayValue = filter.displayValue || filter.value;
    }
    return displayValue;
  }
};

export default CustomReportService;
